<template>
  <div>
    <button class="medicine-detail__information-button" @click="openDialog">
      <span class="medicine-detail__information-button-inner">詳細情報</span>
    </button>

    <dialog
      ref="dialogRef"
      aria-modal="true"
      aria-labelledby="dialog-title"
      @cancel.prevent="closeDialog"
    >
      <div class="modal-mask" @click="closeDialog">
        <div class="modal-wrapper">
          <div class="modal-container" @click.stop>
            <div class="modal-header modal-header--border text-center">
              <div class="medicine-detail-modal__header">
                <span id="dialog-title">詳細情報</span>
                <button
                  type="button"
                  class="medicine-detail-box__button--close"
                  aria-label="閉じる"
                  @click="closeDialog"
                ></button>
              </div>
            </div>

            <div class="modal-body">
              <div class="medicine-detail-modal__contents">
                <slot></slot>
                <div class="medicine-detail-modal__footer">
                  <button
                    type="button"
                    class="button button--tertiary"
                    @click="closeDialog"
                  >
                    閉じる
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </dialog>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const dialogRef = ref<HTMLDialogElement | null>(null);

const openDialog = () => {
  dialogRef.value?.showModal();
};

const closeDialog = () => {
  dialogRef.value?.close();
};
</script>

<style scoped>
dialog::backdrop {
  background-color: transparent;
}
</style>
